import { GS, LogIn, LogOut } from "App";
import { parseCSS } from "scripts/FunctionsBundle";
import styled, { css } from "styled-components";
import Input from "../components/Input";
import { Helmet } from "react-helmet";
import { useState } from "react";
import { useNavigate } from "react-router";

// ################################ INTERFACES & PROPS ################################
type _Base = import("@utils/ClassTypes")._Base;
// LoginScreen => Rename all instances to use
type LoginScreenProps = {} & _Base;

// ################################ FUNCTION COMPONENT ################################
const _LoginScreen = (props: LoginScreenProps) => {
  const [LS] = useState({
    email: "",
    user: "",
    pass: "",
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // ------------------------------------------------------------------------------------ HANDLE SUBMIT
  async function handleSubmit(e) {
    e.preventDefault();

    if (loading) return;
    setLoading(true);
    await LogIn({ ...LS });
    setLoading(false);
    navigate(window.location.pathname);
  }

  // ------------------------------------------------------------------------------------ HANDLE LOGOUT
  async function handleLogOut(e) {
    e.preventDefault();

    if (loading) return;
    setLoading(true);
    await LogOut();
    setLoading(false);
  }

  // ------------------------------------------------------------------------------------ RETURN
  return (
    <div className={props.className + " screen"}>
      <Helmet>
        <title>Iniciar sesión | RSA</title>
      </Helmet>

      <h1>Iniciar sesión</h1>
      <h2>Usuario actual: {GS.currentUser ? GS.currentUser.user : "Ninguno"}</h2>

      {loading && <div className="spinner">Enviando datos...</div>}

      <form
        className={loading ? "disabled loading" : ""}
        onSubmit={handleSubmit}
      >
        <fieldset>
          <legend>Credenciales</legend>

          <Input
            _store={LS}
            _store_var={"email"}
            _preset={"email"}
            _name={"login-email"}
            _placeholder={"nombre@email.com"}
            _label={"Email de la parroquia:"}
            _required={"*"}
          />

          <Input
            _store={LS}
            _store_var={"user"}
            _name={"login-usuario"}
            _label={"Nombre del usuario:"}
            _required={"*"}
            _width={"m"}
          />

          <Input
            _store={LS}
            _store_var={"pass"}
            _type={"password"}
            _name={"login-usuario"}
            _label={"Contraseña del usuario:"}
            _required={"*"}
            _width={"s"}
          />
        </fieldset>

        <button className={"primary big"} disabled={loading}>
          Iniciar nueva sesión
        </button>

        <button
          type={"button"}
          className={"big"}
          onClick={handleLogOut}
          disabled={!GS.currentUser || loading}
        >
          Cerrar sesión actual
        </button>
      </form>
    </div>
  );
};

// ################################ STYLES ################################
const LoginScreen = styled(_LoginScreen).attrs(
  (props: LoginScreenProps): LoginScreenProps => {
    return { ...props };
  }
)`
  ${(props) => css`
    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################
export default LoginScreen;
